/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UnmanagedAllocationType = {
    EXCLUDED: 'excluded'
} as const;
export type UnmanagedAllocationType = typeof UnmanagedAllocationType[keyof typeof UnmanagedAllocationType];


export function instanceOfUnmanagedAllocationType(value: any): boolean {
    for (const key in UnmanagedAllocationType) {
        if (Object.prototype.hasOwnProperty.call(UnmanagedAllocationType, key)) {
            if (UnmanagedAllocationType[key as keyof typeof UnmanagedAllocationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UnmanagedAllocationTypeFromJSON(json: any): UnmanagedAllocationType {
    return UnmanagedAllocationTypeFromJSONTyped(json, false);
}

export function UnmanagedAllocationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnmanagedAllocationType {
    return json as UnmanagedAllocationType;
}

export function UnmanagedAllocationTypeToJSON(value?: UnmanagedAllocationType | null): any {
    return value as any;
}

export function UnmanagedAllocationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): UnmanagedAllocationType {
    return value as UnmanagedAllocationType;
}

